import React, { Component } from 'react';

import './Anomalies.css';

import { homeBanner } from '../../theme/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import routes from '../../utils/routes';
import { API_URL } from "../../utils/config";
import Modal, { ModalClose } from '@acri-tools/react-tools/components/Modal/Modal';
import request from '@acri-tools/react-tools/utils/request';
import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import { create_toast } from '@acri-tools/react-tools/utils/toasts';
import { isLoggedIn } from '@acri-tools/react-tools/utils/login';
import { CSVDownloader } from 'react-papaparse';
import AddAnomaly from './../AddAnomaly/AddAnomaly';
import { connect } from 'react-redux';
import { setGeneral } from '../../redux/actions';
import SelectFilter from '@acri-tools/react-tools/components/SelectFilter/SelectFilter';
import Search from '@acri-tools/react-tools/components/Search/Search';
import SimpleImageSlider from "react-simple-image-slider";
import Footer from '../../components/Footer/Footer';

interface Props {
    general?: any
    setGeneral?: Function
}

interface State {
    loading: boolean
    deleting: boolean
    updating: boolean
    anomalies?: any
    anomaly?: any
    modal_open_delete: boolean
    modal_images: boolean
    images: Array<any>
    impact_list: Array<string>
    categories: any
    types: any
    count: number
    searchParams: any
    services: Array<any>
    filters: any
    search_filter: boolean
    id?: number | undefined
}

type SearchParams = {
    search: string
    orderby: string
    limit: string
    offset: string
    orderbyDirection: string
}

class Anomalies extends Component<Props, State>{
    constructor(props: Props) {
        super(props);
        this.state = {
            loading: true,
            deleting: false,
            updating: true,
            modal_open_delete: false,
            modal_images: false,
            images: [],
            impact_list: [],
            categories: '',
            types: '',
            count: 0,
            searchParams: {
                search: '',
                offset: '0',
                limit: '10',
                orderby: 'id',
                orderbyDirection: 'desc',
            },
            services: [],
            filters: {
                "creation_date_time": { active: true },
                "update_date_time": { active: true },
                "impact_list": { active: true },
            },
            search_filter: false,
            id: -1,
        }
        this.onChange = this.onChange.bind(this);
    }

    async componentDidMount() {
        this.search();
    }

    async componentDidUpdate() {
        if (this.props.general.isRestored) {
            this.search();
            this.props.setGeneral?.({ isRestored: false });
        }
    }

    viewAnomaly = (anomaly: any) => {
        this.props.setGeneral?.({ updated: false, modify_button: true, modal_open: true });
        this.setState({ anomaly: anomaly });
        this.closeUpdateModal();
        this.forceUpdate();
    }

    cancelUpdate = (mainPage?: boolean | undefined) => {
        this.closeUpdateModal();
        this.props.setGeneral?.({ updated: false, modify_button: true });
    }

    closeUpdateModal = () => {
        this.props.setGeneral?.({ modify_anomaly: false, hidden_button: false, view_anomaly: true });
    }

    // Open delete modal
    viewDeleteAnomaly = (id: any) => {
        this.setState({ modal_open_delete: true, id });
    }

    // Open add modal
    openAddAnomaly = () => {
        this.props.setGeneral?.({ modal_new_anomaly: true, modify_anomaly: true });
        this.setState({ anomaly: {} });
    }

    deleteAnomaly = async () => {
        this.setState({ deleting: true })
        try {
            let id;
            if (this.state.id != -1) {
                id = this.state.id;
            }
            // let res = await request(`${API_URL}/api/v1/anomalies/${id}`, { method: 'delete' })

            let data = { status: 'deleted'};
            let res = await request(`${API_URL}/api/v1/anomalies/${id}`, {
                method: 'put',
                data
            })

            this.search();
            this.setState({ modal_open_delete: false, id: -1, anomaly: {} });
            this.props.setGeneral?.({ modal_open: false });
            create_toast({ type: 'success', message: `Successfully deleted anomaly ${id}` });
            this.cancelUpdate(false);
        }
        catch (e) {
            axiosErrorHandler(e, { functionName: `deleteAnomaly` });
            toast_request_error(e);
        }
        finally {
            this.setState({ deleting: false })
        }
    }

    onChange(anomaly: any) {
        this.setState({ anomaly: anomaly });
    }

    getImpactList = () => {
        let formated_list: any;
        formated_list = [];

        this.state.anomaly?.impact_list?.map((impact: string) => {
            formated_list?.push({ 'product_name': impact })
        })
        return formated_list;
    }

    downloadTxtFile = () => {
        const element = document.createElement("a");
        let list = 'product_name\n';
        this.state.anomaly?.impact_list.map((item: any) => {
            list += (`${item}\n`);
        })
        const file = new Blob([list], { type: 'text/plain', endings: 'native' });
        element.href = URL.createObjectURL(file);
        element.download = `anomaly${this.state.anomaly?.id}.txt`;
        document.body.appendChild(element); // Required for FireFox
        element.click();
    }

    searchParamsQuery = (params: SearchParams, filters: any) => {
        let {
            search, limit, offset, orderby, orderbyDirection
        } = params
        let filter = [];
        let filter_checked = [];
        let search_value = '';
        if (search) {
            for (let f of Object.keys(filters)) {
                if (filters[f].active) {
                    let column = filters[f].column ? filters[f].column : f;
                    if (f === "creation_date_time" || f === "update_date_time") {
                        filter.push(`${column}:varchar ge '${search}'`);
                    } else if (f === "impact_list") {
                        filter.push(`${column}:varchar contains '${search}'`);
                    }
                }
            }
            if (filter.length > 0) {
                search_value = filter.join(' or ');
            }
            search_value = `( ${search_value} )`
        }

        if (this.state.types || this.state.categories) {
            this.setState({ search_filter: true });
            if (this.state.types.length > 0) {
                filter_checked.push(
                    `type:varchar in (${this.state.types.map((s: string) => { return `'${s}'` }).join(',')})`
                )
            }
            if (this.state.categories.length > 0) {
                filter_checked.push(
                    `category:varchar in (${this.state.categories.map((s: string) => { return `'${s}'` }).join(',')})`
                )
            }

            if (filter_checked.length > 0) {
                if (search) {
                    search_value += ' and ';
                }
                search_value += filter_checked.join(' and ');
            }
        } else {
            this.setState({ search_filter: false });
        }

        if (search_value) {
            search_value += ' and ';
        }

        search_value += ` status ne 'deleted' `;

        return {
            filter: search_value ? `( ${search_value} )` : undefined,
            limit,
            offset,
            orderby: `${orderby} ${orderbyDirection}`,
        }
    }

    search = async () => {
        this.setState({ loading: true });
        try {
            let res = await request(`${API_URL}/api/v1/anomalies`, {
                method: 'get',
                params: {
                    ...this.searchParamsQuery(this.state.searchParams, this.state.filters),
                    count: true,
                }
            })
            this.setState({ anomalies: res.data.value, count: res.data.count, loading: false });
            this.forceUpdate();

        }
        catch (e) {
            axiosErrorHandler(e, { functionName: `search getAnomalies` });
            toast_request_error(e);
        }
    }

    showImages = (imgs: any) => {
        let illustrations: any = [];
        imgs?.map((image: any) => {
            image = `${API_URL}/data/${image}`;
            illustrations.push({ url: image });
        });
        this.setState({ images: illustrations, modal_images: true });
        this.forceUpdate();
    }

    render() {
        return (
            <Page
                id="anomalies"
                footer={<Footer />}
                banner={{
                    bannerImage: homeBanner,
                    topBar: { routes: routes }
                }}
            >
                <div className="page-content">
                    <div className="title-5">ANOMALIES</div>
                    <div className="centered-content padding">

                        {this.props.general.modal_open &&
                            <Modal
                                className="small"
                                opened={this.props.general.modal_open}
                                close={() => {
                                    if (!this.state.modal_open_delete && !this.props.general.updated && !this.state.modal_images) { this.props.setGeneral?.({ modal_open: false }); this.cancelUpdate(false); }
                                }}
                            >
                                <div className="modal-title">
                                    ANOMALY n° {this.state.anomaly?.id}
                                    <ModalClose close={() => { this.props.setGeneral?.({ modal_open: false }); this.cancelUpdate(false); }} />
                                </div>
                                <div className="modal-content">
                                    {this.props.general.view_anomaly &&
                                        <div id="view_anomaly" className="view-anomaly-no-update">
                                            <div className="view-columns">
                                                <div className="add-first-column">
                                                    <div className="anomaly-modal-parameters">
                                                        <div className="anomaly-modal-parameter-title">Title:</div>
                                                        <div className="anomaly-modal-parameter">{this.state.anomaly?.title}</div>
                                                    </div>

                                                    <div className="anomaly-modal-parameters">
                                                        <div className="anomaly-modal-parameter-title">Status: </div>
                                                        <div className="anomaly-modal-parameter">{this.state.anomaly?.status}</div>
                                                    </div>

                                                    <div className="anomaly-modal-parameters">
                                                        <div className="anomaly-modal-parameter-title">Type: </div>
                                                        <div className="anomaly-modal-parameter">{this.state.anomaly?.type}</div>
                                                    </div>

                                                    <div className="anomaly-modal-parameters">
                                                        <div className="anomaly-modal-parameter-title">Creation date: </div>
                                                        <div className="anomaly-modal-parameter">{this.state.anomaly?.creation_date_time?.substring(0, 10)}</div>
                                                    </div>

                                                    <div className="anomaly-modal-parameters">
                                                        <div className="anomaly-modal-parameter-title">Update date: </div>
                                                        <div className="anomaly-modal-parameter">{this.state.anomaly?.update_date_time?.substring(0, 10)}</div>
                                                    </div>

                                                    <div className="anomaly-modal-parameters">
                                                        <div className="anomaly-modal-parameter-title">Category: </div>
                                                        <div className="anomaly-modal-parameter">{this.state.anomaly?.category}</div>
                                                    </div>

                                                    <div className="anomaly-modal-parameters">
                                                        <div className="anomaly-modal-parameter-title">Severity: </div>
                                                        <div className="anomaly-modal-parameter">{this.state.anomaly?.severity}</div>
                                                    </div>

                                                    <div className="anomaly-modal-parameters">
                                                        <div className="anomaly-modal-parameter-title">NRT status: </div>
                                                        <div className="anomaly-modal-parameter">{this.state.anomaly?.nrt_status}</div>
                                                    </div>

                                                    <div className="anomaly-modal-parameters">
                                                        <div className="anomaly-modal-parameter-title">Archive status: </div>
                                                        <div className="anomaly-modal-parameter">{this.state.anomaly?.archive_status}</div>
                                                    </div>

                                                    <div className="anomaly-modal-parameters">
                                                        <div className="anomaly-modal-parameter-title">Comment: </div>
                                                        <div className="anomaly-modal-parameter">{this.state.anomaly?.comment}</div>
                                                    </div>

                                                    {isLoggedIn() ?
                                                        <div className="anomaly-modal-parameters">
                                                            <div className="anomaly-modal-parameter-title">URL: </div>
                                                            <div className="anomaly-modal-parameter"><a href={this.state.anomaly?.url} target="_blank">{this.state.anomaly?.url}</a></div>
                                                        </div>
                                                        : null}

                                                    <div className="anomaly-modal-parameters">
                                                        <div className="anomaly-modal-parameter-title">Impact List: </div>
                                                        <div className="anomaly-modal-parameter">
                                                            {!this.state.anomaly?.impact_list ?
                                                                null :
                                                                this.state.anomaly.impact_list.length > 2 ?
                                                                    <>
                                                                        <div className="impact-items-view">{this.state.anomaly.impact_list[0]}</div>
                                                                        <br />
                                                                        <div className="impact-items-view">{this.state.anomaly.impact_list[1]}</div>
                                                                        <br />
                                                                        <div className="impact-items-view">...</div>
                                                                        <br />
                                                                    </>
                                                                    :
                                                                    this.state.anomaly?.impact_list?.map((impact: string, idx: any) => {
                                                                        return <div key={idx} > {impact} </div>
                                                                    })
                                                            }
                                                            {this.state.anomaly?.impact_list?.length > 0 ?

                                                                <>
                                                                    <div className="download-buttons">
                                                                        <CSVDownloader
                                                                            type="button"
                                                                            data={this.getImpactList}
                                                                            filename={`anomaly${this.state.anomaly?.id}`}
                                                                            className="download-button"
                                                                        >
                                                                            DOWNLOAD CSV
                                                                </CSVDownloader>
                                                                        <button className="download-button" onClick={this.downloadTxtFile}>DOWNLOAD TXT</button>
                                                                    </div>
                                                                </>
                                                                : null
                                                            }
                                                        </div>
                                                    </div>

                                                    <div className="anomaly-modal-parameters">
                                                        <div className="anomaly-modal-parameter-title">Impact List Type: </div>
                                                        <div className="anomaly-modal-parameter">{this.state.anomaly?.impact_list_type}</div>
                                                    </div>

                                                    <div className="anomaly-modal-parameters">
                                                        <div className="anomaly-modal-parameter-title">Impact List Data Type: </div>
                                                        <div className="anomaly-modal-parameter">
                                                            {this.state.anomaly?.impact_list_data_type ?
                                                                this.state.anomaly?.impact_list_data_type?.map((impact_list_data_type: string, idx: any) => {
                                                                    return <div key={idx} > {impact_list_data_type} </div>
                                                                })
                                                                : null}
                                                        </div>
                                                    </div>

                                                    <div className="anomaly-modal-parameters">
                                                        <div className="anomaly-modal-parameter-title">Illustrations: </div>
                                                        <div className="illustration">
                                                            {this.state.anomaly?.illustration ?
                                                                <div className="show-button">
                                                                    <button className="show-imgs-button" onClick={() => this.showImages(this.state.anomaly.illustration)} >SHOW IMAGES</button>
                                                                </div>
                                                                : null}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="anomaly-modal-delete-button">
                                                {isLoggedIn() ?
                                                    <div className="anomaly-modal-buttons">
                                                        <button id="delete_button_view" className="button-generic" onClick={() => this.viewDeleteAnomaly(this.state.anomaly.id)}>DELETE</button>
                                                    </div>
                                                    : null

                                                }
                                            </div>
                                        </div>
                                    }

                                    {isLoggedIn() ?
                                        <div id="" className="view-anomaly">

                                            <AddAnomaly
                                                onFinish={this.search}
                                                anomaly={this.state.anomaly}
                                                new_anomaly={false}
                                                onAnomalyChange={this.onChange}
                                                mainPage={false}
                                            />


                                            {this.props.general.hidden_button &&
                                                <div id="hidden_button" className="anomaly-modal-buttons">
                                                    {!this.props.general.cancelAndClose ?
                                                        <button id="cancel_button" className="button-generic" onClick={() => this.cancelUpdate(false)}>CANCEL</button>
                                                        : null}
                                                    {this.props.general.cancelAndClose ?
                                                        <button id="cancel_button" className="button-generic" onClick={() => this.cancelUpdate(true)}>CANCEL</button>
                                                        : null}
                                                </div>
                                            }
                                        </div>
                                        : null
                                    }
                                </div>
                            </Modal>
                        }

                        {isLoggedIn() ?
                            <>
                                {this.state.modal_open_delete &&
                                    <Modal
                                        className="small"
                                        opened={this.state.modal_open_delete}
                                        close={() => { this.setState({ modal_open_delete: false }) }}
                                    >
                                        <div className="modal-title">
                                            Are you sure you want to delete anomaly n° {this.state.id ? this.state.id : null}?
                                <ModalClose close={() => { this.setState({ modal_open_delete: false }) }} />
                                        </div>

                                        <div className="anomaly-modal-buttons_delete">
                                            <button id="delete_button" className="button-generic" onClick={this.state.deleting ? undefined : this.deleteAnomaly}>
                                                {
                                                    this.state.deleting ?
                                                        <Spinner white height={14} />
                                                        :
                                                        'DELETE'
                                                }
                                            </button>
                                            <button id="cancel_button_delete" className="button-generic" onClick={() => { this.setState({ modal_open_delete: false }) }} >CANCEL</button>
                                        </div>
                                    </Modal>
                                }
                            </>
                            : null
                        }
                        {this.props.general.modal_update &&
                            <Modal
                                className="small"
                                opened={this.props.general.modal_update}
                                close={() => { if (!this.props.general.updated) { this.props.setGeneral?.({ modal_update: false }); } }}
                            >
                                <div className="modal-title">
                                    ANOMALY n° {this.state.anomaly?.id}
                                    <ModalClose close={() => { this.props.setGeneral?.({ modal_update: false }) }} />
                                </div>
                                <div className="image-slider">
                                    <AddAnomaly
                                        onFinish={this.search}
                                        anomaly={this.state.anomaly}
                                        new_anomaly={false}
                                        onAnomalyChange={this.onChange}
                                        mainPage={true}
                                        viewAnomaly={this.viewAnomaly}
                                    />
                                </div>
                            </Modal>
                        }

                        {this.state.modal_images &&
                            <Modal
                                className="big"
                                opened={this.state.modal_images}
                                close={() => { this.setState({ modal_images: false }) }}
                            >
                                <div className="modal-title">
                                    IMAGES
                                <ModalClose close={() => { this.setState({ modal_images: false }) }} />
                                </div>
                                <div className="image-slider">
                                    <SimpleImageSlider
                                        width={'90%'}
                                        height={'70%'}
                                        images={this.state.images}
                                        showBullets={false}
                                        showNavs={true}
                                        navStyle={2}
                                    />
                                </div>
                            </Modal>
                        }

                        {isLoggedIn() ?
                            <div className="anomaly-add-button">
                                <div className="operation-buttons">
                                    <div className="search-operation custom-button inverted alt icon-only" onClick={this.openAddAnomaly} >
                                        <i className="fas fa-plus" />
                                        <div className="tooltip">
                                            <div className="tooltip-content">
                                                ADD ANOMALY
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {this.props.general.modal_new_anomaly &&
                                    <Modal
                                        className="small"
                                        opened={this.props.general.modal_new_anomaly}
                                        close={() => { if (!this.props.general.updated) { this.props.setGeneral?.({ modal_new_anomaly: false }); } }}
                                    >
                                        <div className="modal-title">
                                            ADD ANOMALY
                                        <ModalClose close={() => { this.props.setGeneral?.({ modal_new_anomaly: false }) }} />
                                        </div>
                                        <AddAnomaly anomaly={this.state.anomaly} mainPage={false} onFinish={this.search} new_anomaly={true} />
                                    </Modal>
                                }
                            </div>
                            : null
                        }
                        {
                            this.state.loading ?
                                <div className="centered">
                                    <Spinner />
                                </div>
                                :
                                <>
                                    <div className="anomaly-filters" >
                                        <SelectFilter
                                            placeholder={'Type'}
                                            filters={[
                                                'On-board anomaly',
                                                'Processing anomaly - L0',
                                                'Processing anomaly - L1B',
                                                'Processing anomaly - L1C',
                                                'Processing anomaly - L2A'
                                            ]}
                                            values={this.state.types ? this.state.types : []}
                                            onChange={(types) => {
                                                this.setState({ types });
                                            }}
                                        />

                                        <SelectFilter
                                            placeholder={'Category'}
                                            filters={['recurrent', 'systematic']}
                                            values={this.state.categories ? this.state.categories : []}
                                            onChange={(categories) => {
                                                this.setState({ categories });
                                            }}
                                        />
                                    </div>
                                    <div className="anomaly-search" >
                                        <Search orderby={['creation_date_time', 'update_date_time', 'impact_list']} count={this.state.count}
                                            filters={this.state.filters} searchParams={this.state.searchParams} search={this.search} >


                                            <div className="anomalies-table">
                                                {
                                                    <table>
                                                        <thead>
                                                            <tr>
                                                                <th>ID</th>
                                                                <th>TITLE</th>
                                                                <th>TYPE</th>
                                                                <th>CATEGORY</th>
                                                                <th>CREATION DATE</th>
                                                                <th>UPDATE DATE</th>
                                                                <th>IMPACT</th>
                                                                <th>NRT STATUS</th>
                                                                <th>SEVERITY</th>
                                                                <th>MORE</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                this.state.anomalies?.map((anomaly: any, idx: number) => (
                                                                    <tr key={idx}>
                                                                        <td>{anomaly.id}</td>
                                                                        <td>{anomaly.title}</td>
                                                                        <td>{anomaly.type}</td>
                                                                        <td>{anomaly.category}</td>
                                                                        <td>{anomaly.creation_date_time?.substring(0, 10)}</td>
                                                                        <td>{anomaly.update_date_time?.substring(0, 10)}</td>
                                                                        <td>
                                                                            <div id="list_column">
                                                                                {!anomaly.impact_list ?
                                                                                    null : anomaly.impact_list[0] ?
                                                                                        <div>{anomaly.impact_list[0]}</div>
                                                                                        : null}

                                                                                {!anomaly.impact_list ?
                                                                                    null : anomaly.impact_list[1] ?
                                                                                        <div><br></br>{anomaly.impact_list[1]}</div>
                                                                                        : null}


                                                                                {anomaly.impact_list?.length > 2 || anomaly.impact_list_type === 'partial' ?
                                                                                    <div><br></br>...</div>
                                                                                    : null}
                                                                            </div>
                                                                        </td>
                                                                        <td>{anomaly.nrt_status}</td>
                                                                        <td>{anomaly.severity}</td>
                                                                        <td>
                                                                            <div className="operation-buttons">
                                                                                <div id="view_icon" className="search-operation custom-button inverted alt icon-only" onClick={() => { this.viewAnomaly(anomaly) }}>
                                                                                    <i className="fas fa-eye" />
                                                                                </div>

                                                                                {isLoggedIn() ?
                                                                                    <>
                                                                                        <div id="modify_icon" className="search-operation custom-button alt icon-only" onClick={async () => { await this.setState({ anomaly }); this.props.setGeneral?.({ updated: false, modify_button: false, view_anomaly: false, modify_anomaly: true, hidden_button: true, modal_update: true }); }} >
                                                                                            <i className="fas fa-pencil-alt" />
                                                                                        </div>

                                                                                        <div id="delete_icon" className="search-operation custom-button alt icon-only" onClick={() => { this.viewDeleteAnomaly(anomaly.id) }}>
                                                                                            <i className="fas fa-trash-alt" />
                                                                                        </div>
                                                                                    </>
                                                                                    : null}
                                                                            </div>

                                                                        </td>
                                                                    </tr>




                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                }
                                            </div>
                                        </Search>
                                    </div>
                                </>
                        }
                    </div>
                </div>
            </Page >
        );
    }

};

export default connect((state: any) => {
    return {
        general: state.general
    }
}, {
    setGeneral
})(Anomalies);